import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import CountUp from 'react-countup';
import { Link } from 'react-router-dom';
import RollingText from "../RollingText/RollingText";
import abImg from '../../images/about-1.jpg';

gsap.registerPlugin(ScrollTrigger);

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    useEffect(() => {

        const fadeElements = document.querySelectorAll(".fade_bottom");
        const isMobile = window.innerWidth < 1023;

        gsap.set(fadeElements, { y: 30, opacity: 0 });

        fadeElements.forEach((item) => {
            const animation = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: isMobile ? "top center+=100" : "top center+=200",
                },
            });

            animation.to(item, {
                y: 0,
                opacity: 1,
                ease: "power2.out",
                duration: 1.5,
                stagger: isMobile ? 0 : 0.2,
            });
        });

        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, []);

    useEffect(() => {

        const defaults = {
            duration: 1.2,
            ease: "power4.out",
            animation: "fade_from_bottom",
            once: false,
        };

        const animations = {
            fade_from_bottom: { y: 180, opacity: 0 },
            fade_from_top: { y: -180, opacity: 0 },
            fade_from_left: { x: -180, opacity: 0 },
            fade_from_right: { x: 180, opacity: 0 },
            fade_in: { opacity: 0 },
            rotate_up: { y: 180, rotation: 10, opacity: 0 },
        };

        const scrollAnimations = document.querySelectorAll(".scroll-text-animation");

        scrollAnimations.forEach((box) => {
            const animationType = animations[box.dataset.animation] || animations[defaults.animation];

            gsap.from(box, {
                ...animationType,
                duration: box.dataset.animationDuration || defaults.duration,
                scrollTrigger: {
                    trigger: box,
                    start: "top bottom+=10%",
                    toggleActions: "play none none reverse",
                    markers: false,
                },
            });
        });

        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, []);

    return (
        <section className="about-section">
            <div className="container">
                <div className="about-wraper">
                    <h2 className="scroll-text-animation" data-animation="fade_from_left" style={{fontSize: window.innerWidth >= 768 ? "48px" : "28px", lineHeight: window.innerWidth >= 768 ? "70px" : "32px",fontWeight:"700"}}>
                        환경을 생각하며 도시광산의 { window.innerWidth >= 768 ? " " : <br /> } 리싸이클을 { window.innerWidth >= 768 ? <br /> : " " } 선도하는 기업 { window.innerWidth >= 768 ? " " : <br /> }
                        <span style={{color:"#0B0056",fontWeight:"700"}}>㈜엠알메탈로</span>입니다.</h2>
                    <p className="scroll-text-animation" data-animation="fade_from_left" style={{
                        fontSize: window.innerWidth >= 768 ? "24px" : "18px",
                        color:"#000",
                        lineHeight: window.innerWidth >= 768 ? "45px" : "32px",fontWeight:"400"
                    }}>
                        {window.innerWidth >= 768 ? (
                            <>
                                산업폐수처리업과 폐수재활용업에서 20년이라는 다년간의 경험에서 얻은 <br />
                                자원순환기술을 바탕으로 하여, R&D 기술부재로 인하여 사장되어 오던 도시광산의 <br /> 
                                폐자원을 전략적인 대상금속으로 선정하고 자원추출의 전문성을 높여 오고 있습니다. <br />
                                고부가가치산업인 도시광산자원 리싸이클을 주도하고 있는 전문기술기업 입니다.
                            </>
                        ) : (
                            <>
                                산업폐수처리업과 폐수재활용업에서 { (window.innerWidth < 400 ) && <br /> } 20년이라는 { (window.innerWidth > 400 ) && <br /> }
                                다년간의 경험에서 얻은 { (window.innerWidth < 400 ) && <br /> } 자원순환기술을 바탕으로 { (window.innerWidth > 400 ) && <br /> }
                                하여,R&D { (window.innerWidth < 400 ) && <br /> } 기술부재로 인하여 사장되어 오던 { (window.innerWidth > 400 ) && <br /> } 
                                도시광산의 폐자원을 전략적인 대상금속으로 { (window.innerWidth > 400 ) && <br /> } 
                                선정하고 { (window.innerWidth < 400 ) && <br /> } 자원추출의 전문성을 높여 오고 있습니다. <br />
                                고부가가치산업인 도시광산자원 리싸이클을 <br /> 
                                주도하고 있는 전문기술기업 입니다.
                            </>
                        )}
                    </p>
                    <div className="scroll-text-animation" data-animation="fade_from_left">
                        <Link onClick={ClickHandler} to="/contact">
                            <RollingText text="견적 문의하기"  />
                            <i className="ti-arrow-top-right" style={{marginLeft:"10px"}}></i></Link>
                    </div>
                    <div className="funfact scroll-text-animation" data-animation="fade_from_right">
                        <div className="item">
                            <h3 style={{fontWeight:"500"}}>
                                <CountUp end={20} enableScrollSpy />
                                <span>년+</span>
                            </h3>
                            <p style={{color:"#61666E"}} >엠알메탈로 연혁</p>
                        </div>
                        <div className="item">
                            <h3 style={{fontWeight:"500"}}>
                                <CountUp end={8000} enableScrollSpy />
                                <span>건+</span>
                            </h3>
                            <p style={{color:"#61666E"}} >누적 사업 현황</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;
